type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
}: SectionHeadingProps) {
  const alignment = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`max-w-2xl ${alignment}`}>
      <span className="inline-flex items-center gap-2 text-xs md:text-sm font-medium tracking-wide text-primary-600">
        <span className="w-6 h-px bg-primary-400"></span>
        {eyebrow}
      </span>
      <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
        {title}
      </h2>
      {desc && (
        <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
          {desc}
        </p>
      )}
    </div>
  );
}